import React from "react";
import styles from "./Richard.module.css";

const Richard = () => {
  return (
    <div className={styles.container}>
      <div className={styles.mimo}>
        <div>
          <div>Richard</div>
          <div>Publishing Manager</div>
        </div>
      </div>

      <div className={styles.textBox}>
        <div className={styles.textList}>
          <div>
            다양한 유저가 있는 만큼, 게임을 만드는 사람들도 굉장히 많아요.
          </div>
          <br />
          <div>
            퍼블리싱 매니저는 여러 나라에 있는 게임스튜디오와의 협업을 통해
            퍼블리싱을 진행하는 일을 메인업무로 하고 있어요.
          </div>
          <br />
          <div>
            외국인 직원들과 함께 프로젝트를 진행하고, 전세계에 있는 게임
            개발자들과 협업을하는 과정에서, 회사와 함께 나도 성장하고 있구나
            라는 성취감을 느끼고 있어요.
          </div>
        </div>
        <div>Richard/ Publishing Manager</div>
      </div>
    </div>
  );
};

export default Richard;
